
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('rect',{attrs:{"x":"0.75","y":"0.75","width":"22.5","height":"22.5","rx":"1.5","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"13","y1":"15.75","x2":"18.75","y2":"15.75","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('line',{attrs:{"x1":"5.25","y1":"15.75","x2":"8","y2":"15.75","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M13,15.75a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,13,15.75Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px","fill-rule":"evenodd"}}),_c('line',{attrs:{"x1":"14","y1":"8.25","x2":"5.25","y2":"8.25","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M19,8.25a2.5,2.5,0,1,0-2.5,2.5A2.5,2.5,0,0,0,19,8.25Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px","fill-rule":"evenodd"}})])])
          )
        }
      }
    